import React, { FC, useEffect, useRef } from 'react';
import BaseModal from 'components/BaseModal';
import { BaseModalProps } from 'components/BaseModal/types';
import * as Styled from './styled';

const Modal: FC<BaseModalProps> = ({ children, ...rest }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const baseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (rest.isOpen) {
      baseRef?.current?.classList.add('animated');
      setTimeout(() => {
        contentRef.current?.classList.add('animated');
      }, 100);
    }
  }, [rest.isOpen]);

  return (
    <BaseModal {...rest} innerRef={baseRef}>
      <Styled.Stage ref={contentRef}>
        <Styled.PaperCustom>{children}</Styled.PaperCustom>
      </Styled.Stage>
    </BaseModal>
  );
};

export default Modal;
